module.exports = __webpack_public_path__ + "img/antes_despues_314.ad5ccf88.png";